import { render, staticRenderFns } from "./Sermons.vue?vue&type=template&id=9c3c0d84&scoped=true"
import script from "./Sermons.vue?vue&type=script&lang=js"
export * from "./Sermons.vue?vue&type=script&lang=js"
import style0 from "./Sermons.vue?vue&type=style&index=0&id=9c3c0d84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c3c0d84",
  null
  
)

export default component.exports